import Vue from 'vue';
import Router from 'vue-router';
import Landing from '../views/Landing.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing
    },
    {
      path: '/organization/:id',
      name: 'main',
      component: () => import(/* webpackChunkName: 'main' */ '../views/Main'),
      redirect: '/organization/:id/info',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'info',
          name: 'info',
          component: () => import(/* webpackChunkName: 'organization' */ '../views/Organization'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'scholars',
          name: 'scholars',
          redirect: '/organization/:id/scholars',
          component: () => import(/* webpackChunkName: 'scholars' */ '../views/Scholar'),
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: '/',
              name: 'mainscholar',
              component: () => import(/* webpackChunkName: 'mainscholar' */ '../views/ScholarMain'),
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'add',
              name: 'addscholar',
              component: () => import(/* webpackChunkName: 'scholardetail' */ '../views/ScholarAdd'),
              meta: {
                requiresAuth: true
              }
            },
            {
              path: ':scholarId',
              name: 'viewscholar',
              component: () => import(/* webpackChunkName: 'viewscholar' */ '../views/ScholarDetail'),
              props: true,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: 'admins',
          name: 'admins',
          component: () => import(/* webpackChunkName: 'admins' */ '../views/Admin'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import(/* webpackChunkName: 'notfound' */ '../views/NotFound')
    },
    {
      path: '*',
      redirect: 'notfound'
    }
  ]
});
